export const PsychometricConfig = {
    //thomasEndPoint: "https://localhost:7272/",
    // thomasEndPoint: "https://dev-thomas.zenithr.net/",
    //thomasEndPoint: "https://elevate-staging-api.zenithr.net/",
    thomasCallBackUrl:"",
    thomasEndPoint: "https://elevate.apis.zenithr.net/",
    thomasAuthorizationAPI: "https://identity.thomasinternational.net/connect/token",
    thomasAssessmentOrderAPI: "https://partner.thomasinternational.net/hr/v1/%CLIENTID%/AssessmentOrders/",
    zenithrThomasAssessmentOrderAPI: "https://us-central1-exitanalysis-a6325.cloudfunctions.net/createThomasAssessment", // BECAUSE CORS POLICY ISSUE
    DefaultLogo: "https://firebasestorage.googleapis.com/v0/b/exitanalysis-a6325.appspot.com/o/thomas-logo-hub.png?alt=media&token=224305ad-ed43-4588-b416-1f72fbe7ef9b",
}

export const PsychometricConfigOM = {
    thomasEndPoint: "https://om.elevate-apis.zenithr.net/",
    thomasAuthorizationAPI: "https://identity.thomasinternational.net/connect/token",
    thomasAssessmentOrderAPI: "https://partner.thomasinternational.net/hr/v1/%CLIENTID%/AssessmentOrders/",
    zenithrThomasAssessmentOrderAPI: "https://us-central1-exitanalysis-a6325.cloudfunctions.net/createThomasAssessment", // BECAUSE CORS POLICY ISSUE
    DefaultLogo: "https://firebasestorage.googleapis.com/v0/b/exitanalysis-a6325.appspot.com/o/thomas-logo-hub.png?alt=media&token=224305ad-ed43-4588-b416-1f72fbe7ef9b",
}
export const PsychometricConfigSA = {
    thomasEndPoint: "https://sa.elevate-apis.zenithr.net/",
    thomasAuthorizationAPI: "https://identity.thomasinternational.net/connect/token",
    thomasAssessmentOrderAPI: "https://partner.thomasinternational.net/hr/v1/%CLIENTID%/AssessmentOrders/",
    zenithrThomasAssessmentOrderAPI: "https://us-central1-exitanalysis-a6325.cloudfunctions.net/createThomasAssessment", // BECAUSE CORS POLICY ISSUE
    DefaultLogo: "https://firebasestorage.googleapis.com/v0/b/exitanalysis-a6325.appspot.com/o/thomas-logo-hub.png?alt=media&token=224305ad-ed43-4588-b416-1f72fbe7ef9b",
}
export const PsychometricConfigEU = {
    thomasEndPoint: "https://apis.aaplus.global/",
    thomasAuthorizationAPI: "https://identity.thomasinternational.net/connect/token",
    thomasAssessmentOrderAPI: "https://partner.thomasinternational.net/hr/v1/%CLIENTID%/AssessmentOrders/",
    zenithrThomasAssessmentOrderAPI: "https://us-central1-exitanalysis-a6325.cloudfunctions.net/createThomasAssessment", // BECAUSE CORS POLICY ISSUE
    DefaultLogo: "https://firebasestorage.googleapis.com/v0/b/exitanalysis-a6325.appspot.com/o/thomas-logo-hub.png?alt=media&token=224305ad-ed43-4588-b416-1f72fbe7ef9b",
}